import Cookies from "js-cookie";
import { getBestAdPlacement, getBestAdInfo } from "@/api/ad";
const state = {
  backflow: Cookies.get("backflow"), //单向逆流阀，用于记录路由返回的位置
  currentRouteAdSeat: null,
  currentPageADInfo: null,
  chosenTime: null,
  jntcImg: null,
  imgBtn: null
};

const mutations = {
  SET_BACKFLOW: (state, backflow) => {

    state.backflow = backflow;
    Cookies.set("backflow", backflow, 7200);
  },
  SET_CURRENT_ROUTE_AD_SEAT: (state, data) => {
    state.currentRouteAdSeat = data;
  },
  SET_CHOSENTIME: (state, data) => {
    state.chosenTime = data;
  },
  SET_JNTCIMG: (state, data) => {
    state.jntcImg = data;
  },
  SET_IMGBTN: (state, data) => {
    state.imgBtn = data;
  },
  SET_CURRENT_PAGE_INFO: (state, data) => {
    state.currentPageADInfo = data;
  },
  CLEAR_CURRENT_PAGE_AD: state => {
    state.currentPageADInfo = null;
    state.currentRouteAdSeat = null;
  }
};

const actions = {
  SetJntcimg ({ commit }, data) {
    commit("SET_JNTCIMG", data);
  },
  SetChosentime ({ commit }, data) {
    commit("SET_CHOSENTIME", data);
  },
  SetImgbtn ({ commit }, data) {
    commit("SET_IMGBTN", data);
  },
  setBackflow ({ commit }, backflow) {
    commit("SET_BACKFLOW", backflow);
  },
  // 根据停车场、页面名称获取广告位
  // GetAdSeat ({ commit }, params) {
  //   return new Promise((resolve, reject) => {
  //     getBestAdPlacement(params)
  //       .then(res => {
  //         const data = res.body;
  //         if (data != null && Object.keys(data).length > 0) {
  //           commit("SET_CURRENT_ROUTE_AD_SEAT", data);
  //         }
  //         resolve(data);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // },
  // 根据广告位获取广告信息
  GetAdInfo ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getBestAdInfo(params)
        .then(res => {
          const data = res.body.data;
          if (data != null && Object.keys(data).length > 0) {
            let bidSeat = data.bidSeat;
            let defaultSeat = data.defaultSeat;
            let finalSeat = defaultSeat || bidSeat;
            commit("SET_CURRENT_PAGE_INFO", finalSeat);
          }
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  ClearAdSeatAndInfo ({ commit }) {
    commit("CLEAR_CURRENT_PAGE_AD");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
